import React from "react";


import { connect } from "react-redux";

import LeftMenu from "../leftSideComponent/LeftSide";
import Header from "../headerComponent/Header";
import history from "../../auth/history";
import UploadedHistory from "./UploadedHistory";
import ConsumerUploadAndView from "./ConsumerUploadAndView";
import Footer from "../footerComponent/Footer";


class ManageConsumers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: ''
		}
	}

	componentDidMount() { }
	componentWillUnmount() {
	}


	render() {
		console.log('Inside render');
		return (

			<div>
				<div class="main">
					<LeftMenu />
					<div class="right-side">
						<div class="container-fluid">
							<Header />
							<div class="row">
								<ConsumerUploadAndView />
								<UploadedHistory />
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
		miscReduce: { otpRefNo, phone } }
) => ({
	errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(ManageConsumers);
